import { Component, OnInit } from '@angular/core';
import { NavService } from 'src/app/shared/services/nav.service';
import { navItemsAdmin } from './sidebar-data-admin';
import { NavItem } from './nav-item/nav-item';
import { PerfilEnum } from 'src/app/shared/enums/perfil.enum';
import { navItemsRestaurante } from './sidebar-data-restaurante';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { BrandingComponent } from './branding.component';
import { AppNavItemComponent } from './nav-item/nav-item.component';
import { CommonModule } from '@angular/common';
import { AuthService } from 'src/app/shared/services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [BrandingComponent, TablerIconsModule, MaterialModule, AppNavItemComponent, CommonModule],
  templateUrl: './sidebar.component.html',
})
export class SidebarComponent implements OnInit {
  navItems: NavItem[] = [];
  showProButtons = false;

  constructor(
    public navService: NavService,
    private authService: AuthService,
    private router: Router,
  ) {
    this.showProButtons = !!(this.authService.perfil === PerfilEnum.RESTAURANTE && this.authService.planoPro !== 'true')
  }

  async ngOnInit(): Promise<void> {
    const perfil = localStorage.getItem('perfil') || sessionStorage.getItem('perfil');
    if (perfil === PerfilEnum.ADMINISTRADOR) {
      this.navItems = navItemsAdmin;
      return;
    }

    this.navItems = [...navItemsRestaurante];
  }

  async redicionarMeuPlano(){
    await this.router.navigate(['/meu-plano'])
  }
}
